// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"ZJ-z","carouselContainer":"_J-z"};